import React, { useEffect } from "react";
import {useDispatch, useSelector} from "react-redux";
import { useCallbackContext } from "../../../../contexts/CallbackContext";
import {
    PaymentActions, PaymentButton, PaymentIcon, PaymentMessage, PaymentRoot, PaymentTitle
} from "./PaymentPopupComponents";
import {setEventData} from "../../../../features/askEmma/askEmmaSlice";

const PaymentStatusPopupContainer = () => {
    const paymentStatusPopupState = useSelector(state => state.paymentStatusPopup);
    const { getCallback, unregisterCallback } = useCallbackContext();
    const dispatch = useDispatch();

    const isVisible = paymentStatusPopupState.isVisible || false;
    const configObj = paymentStatusPopupState.config || {};

    let onConfirmKey = configObj.onConfirmKey || null;
    let onCancelKey = configObj.onCancelKey || null;

    let title = configObj.title || '';
    let icon = configObj.icon || '';
    let variant = configObj.variant || '';
    let message = configObj.message || '';
    let confirmBtnText = configObj.confirmBtnText || '';
    let cancelBtnText = configObj.cancelBtnText || '';
    let confirmBtnLoading = configObj.confirmBtnLoading || '';
    let cancelBtnLoading = configObj.cancelBtnLoading || '';
    let textWhileProcessingConfirmBtn = configObj.textWhileProcessingConfirmBtn || '';
    let textWhileProcessingCancelBtn = configObj.textWhileProcessingCancelBtn || '';

    useEffect(() => {
        const confirmKey = onConfirmKey;
        const cancelKey = onCancelKey;

        return () => {
            if (confirmKey) {
                unregisterCallback(confirmKey);
            }
            if (cancelKey) {
                unregisterCallback(cancelKey);
            }
        };
    }, []);

    useEffect(() => {
        if(isVisible) {
            dispatch(setEventData({ eventName: 'patientPortal_startnoworlater' }))
        }
    }, [isVisible]);

    const handleConfirm = async () => {
        const confirmCallback = getCallback(onConfirmKey);
        if (confirmCallback) {
            await confirmCallback();
        }
    };

    const handleCancel = async () => {
        const cancelCallback = getCallback(onCancelKey);
        if (cancelCallback) {
            await cancelCallback();
        }
    };

    return (
        <>
            {isVisible && (
                <PaymentRoot>
                    <PaymentTitle title={title} variant={variant}/>
                    <PaymentIcon icon={icon} alt="Icon"/>
                    <PaymentMessage message={message}/>
                    <PaymentActions>
                        <PaymentButton
                            label={cancelBtnText}
                            onClick={handleCancel}
                            isLoading={cancelBtnLoading}
                            textWhileLoading={textWhileProcessingCancelBtn}
                            variant="secondary"
                        />
                        <PaymentButton
                            label={confirmBtnText}
                            onClick={handleConfirm}
                            variant="primary"
                            isLoading={confirmBtnLoading}
                            textWhileLoading={textWhileProcessingConfirmBtn}
                        />
                    </PaymentActions>
                </PaymentRoot>
            )}
        </>
    );
};

export default PaymentStatusPopupContainer;
